var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wordCarousel"},[_c('div',[_c('ul',{class:['flip-text', _vm.isDarkMode ? 'dark' : '']},_vm._l((_vm.quotes),function(quote,index){return _c('li',{key:index,class:[
          'content__container__list__item font-weight-bold',
          _vm.isDarkMode ? 'white--text' : '',
          _vm.isMobileViewPort ? 'text-subtitle-2' : 'headline' ]},[_vm._v(" "+_vm._s(quote)+" ")])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }